export class CreateAgencyRequest{
    iataCode: string;
    language: string;
}